import React, {useState, useRef, useContext} from 'react';
import {LazyLoadImage} from 'react-lazy-load-image-component';
import {MDBCheckbox} from 'mdb-react-ui-kit';
import {Card, ListGroup} from 'react-bootstrap';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faTrash, faPencilAlt, faArrowRight} from '@fortawesome/free-solid-svg-icons';
import { MadricContext } from '../../../Context/MadricContext';
import {useNavigate} from 'react-router';
import { getPhotoUrl } from '../../../services/MadricService';


/**
 *  L'accueil
 * @param {*} props props
 * @return {JSX}
 */
function Photo(props) {
    const navigate = useNavigate();
    const {setWhatToShow, setActiveLink} = useContext(MadricContext);
    const returnTo = 'global';
    const photo = props.photo;

    async function photoOnClick(){
      const res = await getPhotoUrl(photo.id, photo.place_id)
      photo.url = res.data
      navigate('/UpdatePhoto', {state: {photo, returnTo}});
      setActiveLink('chantiers')
    }

  return (
    <div className="checkin-container">
      <Card className="checkin-card">
        <Card.Header className="checkin-header">
          <span style={{fontWeight: 'bold', textDecoration: 'underline'}}>{props.photo.type ==='photo' ? 'PHOTO' : 'FACTURE'}</span> {props.formatDate(props.photo.date)}
          <button style={{marginLeft:"5px"}} className="checkin-pagination-button float-end" onClick={() => {props.photo.type ==='photo' ? setWhatToShow('3') : setWhatToShow('4'); navigate('/chantier/' + props.photo.place_id); setActiveLink('chantiers')}}><FontAwesomeIcon icon={faArrowRight} /></button>
          <button className="checkin-pagination-button float-end" onClick={() => photoOnClick()}><FontAwesomeIcon icon={faPencilAlt} /></button>
        </Card.Header>

        <ListGroup variant="flush">
        <ListGroup.Item className="checkin-list-item" style={{fontWeight:"bold", fontSize:"18px"}}>
          {props.photo.user_name}
          </ListGroup.Item>
        <ListGroup.Item className="checkin-list-item">
          Projet: {props.photo.chantier}
          </ListGroup.Item>

          {props.photo.type === 'facture' ?
        <ListGroup.Item className="checkin-list-item ">
          Facture: {props.photo.facturename}
        </ListGroup.Item> : ''}
          {props.photo.type === 'facture' ?
        <ListGroup.Item className="checkin-list-item ">
          Montant: {props.photo.montant} $
        </ListGroup.Item> : ''}


          <ListGroup.Item>
            <MDBCheckbox
              name="extra1"
              id="inlineCheckbox111"
              defaultChecked={props.photo.extra1}
              label="Extra possible"
              inline
            />
            {localStorage.getItem('admin') === '1' ? (
            <React.Fragment>
              <MDBCheckbox
                name="extra2"
                id="inlineCheckbox222"
                defaultChecked={props.photo.extra2}
                label="Extra valider"
                inline
              />
              <MDBCheckbox 
                name="extra3"
                id="inlineCheckbox333"
                defaultChecked={props.photo.extra3}
                label="Extra confirmer"
                inline
              />
              <MDBCheckbox
                name="avancement"
                id="inlineCheckbox333"
                defaultChecked={props.photo.avancement}
                label="Avancement"
                inline
              />
            </React.Fragment>
          ) : (
            ' '
          )}
          </ListGroup.Item>
          <ListGroup.Item className="checkin-list-item ">
          Note: {props.photo.note}
          </ListGroup.Item>
        </ListGroup>
      </Card>
    
    </div>
  );
}

export default Photo;
